/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
import question from '05Images/toolTipWhite.svg';
import questionBlack from '05Images/toolTipBlack.svg';
import { assets } from "03CommonApiParts/Configuration";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */ 

/* ====== Styled Components ====== */
/* ------ ツールチップ ------*/
const SdivIconWrapper = styled.div`//ツールチップ枠
    display: flex;
    align-items: center;
    margin-left: 3px;
    :hover label{
        display: block;
    }
`;
const SlabelBalloon = styled.label`//テキスト表示
    text-align:center;
    display: none;
    position: absolute;
    border-radius: 3px;
    z-index: 60;
    bottom: 10px;
    left:  ${props=>props.baloonPosition ?props.baloonPosition:' 7px'};
    background-color: #4b4b4b;
    color: #ffffff;
    padding: 4px 8px;
    width: ${props=>props.width};
    min-width:280px;
    max-width:550px;
    transform:translate(-20px,-14px);
    overflow-wrap:break-word;
    /* white-space: ${props=>props.width ?'normal':'nowrap'}; */
    :after {
        position: absolute;
        top: 100%;
        left: ${props=>props.trianglePosition ?props.trianglePosition:' 15px'};
        border: 5px solid transparent;
        border-top: 10px solid #4b4b4b; 
      content: " ";
    }
`;
const SdivFlex = styled.div`//横並び枠
    position: relative;
    vertical-align: middle;
    align-items: center;
`;
const Sdiv = styled.div`//アイコン位置調整
    position: relative;
    fill:blue;
    margin-top: -1px;
    height: 14px;
    line-height: 0;
    z-index: 20;
`;
const SsvgIcon = styled.svg`//アイコン
    width: 14px;
    height: 14px;
    fill: ${props => props.color};
    fill:blue;
`;
/*==================*/
/*=====  Main  =====*/
/*==================*/
export const Tooltip = (props) => {

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    const {color, mark, exp,markColor,baloonPosition,trianglePosition,width,} = props;
    /*--------------------------*/
    /*-----  Start Render  -----*/
    /*--------------------------*/
    return(
        /*------ 説明文がなければ表示しない ------*/
        exp ?
        <SdivIconWrapper>
            <SdivFlex>
                <Sdiv>
                    {mark === true ?
                        markColor === 'black'?
                            <SsvgIcon >
                                <use xlinkHref={`${questionBlack}#toolTipBlack`} ></use>
                            </SsvgIcon>
                            :
                            <SsvgIcon >
                                <use xlinkHref={`${question}#toolTipWhite`}></use>
                            </SsvgIcon>
                            
                            :<></>}
                </Sdiv>
                {exp ? 
                <SlabelBalloon className='baseText' style={{fontSize:assets().size.baseText}}color={color} baloonPosition={baloonPosition} trianglePosition={trianglePosition} width={width}>
                {exp.split('\n').map((item, index) => (  
                    <p key={`${item}${index}`}style={{margin: '0px', textAlign: 'left'}}>{item}</p>
                ))}
                </SlabelBalloon>
                :<></>}
            </SdivFlex>
        </SdivIconWrapper>
        :<></>
    )
}